export const translations = {
  en: {
    nav: {
      about: 'Home',
      services: 'Services',
      distribution: 'Distribution',
      trading: 'Trading',
      contact: 'Contact'
    },
    hero: {
      title: 'ROOTED IN THE UAE, CONNECTED TO THE WORLD',
      subtitle: 'We connect Europe, Asia, and the Middle East through bidirectional trade flows, sourcing from key producers and delivering high-quality products to regional buyers.'
    },
    about: {
      title: 'About Us',
      companyName: 'ARIA MEA Ventures',
      description1: 'Strategically headquartered in the UAE, we serve as a vital link in the global supply chain for Commodities, HoReCa, and FMCG products. Although we are a fresh face in the industry, our foundation is built on decades of collective experience. We offer a unique advantage: the deep market wisdom of seasoned veterans combined with the agility and responsiveness of a modern operator.',
      description2: 'We understand that in today\'s complex market, simply delivering a product is not enough. We pride ourselves on being a strategic partner who tailors solutions to fit your exact requirements. We don\'t believe in rigid processes, instead, we listen, adapt, and customize our approach whether it\'s sourcing niche products or navigating challenging supply chains to ensure your operational goals are met with precision.',
      stat1: '15+ Years',
      stat1Label: 'Cross-regional business execution',
      stat2: '$60M+',
      stat2Label: 'Global Transactional Value',
      stat3: '60,000+',
      stat3Label: 'Tons Traded',
      description3: 'What sets us apart is our uncompromising commitment to excellence. We go further than most to secure your success, driven by a results-oriented mindset and a deep respect for our partners\' objectives. We understand your unique challenges yet determined to overcome obstacles and get the job done. We are here to build a reputation based on trust, transparency, and results that speak for themselves.'
    },
    services: {
      title: 'Services',
      subtitle: 'Integrated support for companies expanding into the Middle East and Asia. From market entry and sourcing to logistics and local representation, we deliver practical, on-ground execution supported by years of regional experience.',
      whatWeOffer: 'What We Offer:',
      service1: {
        title: 'Market Expansion Support',
        description: 'Unlock new opportunities across the UAE and GCC with targeted insights and on-ground understanding of regional dynamics. We help brands enter new markets efficiently while reducing risk and uncertainty.',
        benefits: [
          'Market research and feasibility studies',
          'Regulatory compliance and licensing support',
          'Local partner identification',
          'Cultural adaptation strategies',
          'Risk assessment and mitigation planning'
        ]
      },
      service2: {
        title: 'Cross-Border Sourcing & Trading',
        description: 'Gain access to reliable suppliers across Europe, Asia, and Africa. We manage sourcing, supplier verification, compliance documentation, and trade execution for smooth and consistent supply.',
        benefits: [
          'Verified supplier network across 3 continents',
          'Quality control and product inspection',
          'Competitive pricing negotiations',
          'Complete documentation and compliance',
          'Container and bulk shipment coordination'
        ]
      },
      service3: {
        title: 'Logistics & Supply Chain Coordination',
        description: 'Secure deliveries with coordinated logistics, port handling, and shipment oversight. We cover products from flour and FMCG raw materials to premium seafood, ensuring clarity and control across borders.',
        benefits: [
          'End-to-end logistics management',
          'Temperature-controlled cold chain solutions',
          'Port handling and customs clearance',
          'Real-time shipment tracking',
          'Insurance and risk management'
        ]
      },
      service4: {
        title: 'Business Development & Local Representation',
        description: 'Expand your presence in the Middle East with a partner who understands the region. We support B2B outreach, distributor connections, and brand positioning for companies entering or growing in the UAE.',
        benefits: [
          'B2B networking and introductions',
          'Distributor and retailer connections',
          'Brand positioning and market entry strategy',
          'Sales channel development',
          'Long-term partnership facilitation'
        ]
      }
    },
    whyUs: {
      title: 'Why Work With Us',
      reason1: {
        title: 'Trust',
        description: 'We operate with transparency and integrity across sourcing, verification, and delivery. Clear information, honest timelines, and consistent follow-through—no surprises or inflated promises.'
      },
      reason2: {
        title: 'Reliability',
        description: 'We prioritize reliable supply and predictable execution through disciplined coordination, verified suppliers, and seamless logistics to reduce uncertainty.'
      },
      reason3: {
        title: 'Niche Product Alignment',
        description: 'We focus on high-value, specialized products with market gaps, matching specific needs with the best sourcing options to ensure relevance, quality, and long-term value.'
      },
      reason4: {
        title: 'Market Knowledge',
        description: 'Over a decade of experience in the UAE with strong connections across Europe, Asia, and the Balkans. We understand market expectations, cultural nuances, and operational requirements.'
      },
      reason5: {
        title: 'Long-Term Partnership Approach',
        description: 'We focus on sustainable relationships rather than transactions, building stable, mutually beneficial partnerships that grow over time with hotel groups, distributors, or industrial clients.'
      },
      closing: 'With years of cross-regional business development and sourcing experience, ARIA MEA Ventures acts as a strategic partner committed to transparency, dependable operations, and tailored solutions.'
    },
    distribution: {
      title: 'Distribution',
      subtitle: 'Reliable distribution networks connecting premium products with regional markets',
      intro: 'We provide comprehensive distribution solutions across the Middle East, ensuring your products reach the right markets with the highest standards of quality and efficiency.',
      productsTitle: 'Products',
      featuredClient: {
        title: 'VIYA CRAB',
        name: 'Premium Pasteurized Crab Meat (Thailand)',
        description: 'Viya Crab (Siam Crab Products Co., Ltd.) is one of the most respected Thai producers of hand-picked, pasteurized Blue Swimming Crab meat. The company operates with full vertical integration, managing every stage from sourcing to final packaging to ensure consistent quality and a stable flow of products throughout the year. Viya Crab products benefit from a refrigerated shelf life of up to 18 months and meet the highest international food safety standards, being certified BRC Grade A, ISO 9001:2015, HACCP and GMP. The entire production process is supported by rigorous sustainability practices and a complete traceability system, guaranteeing transparency and accountability in the supply chain.',
        features: ['Colossal Lump – top-grade, 40–50 pcs', 'Jumbo Lump – 75–110 pcs', 'Super Lump – premium blend', 'Backfin Lump – large mixed pieces', 'Special – flake-style meat', 'Claw Meat – rich, flavourful, ideal for soups & bisques']
      },
      capabilities: {
        title: 'Distribution Capabilities',
        items: [
          {
            title: 'Temperature-Controlled Logistics',
            description: 'State-of-the-art cold chain management for seafood and perishables'
          },
          {
            title: 'Regional Coverage',
            description: 'Extensive network across UAE, Saudi Arabia, Qatar, and broader GCC'
          },
          {
            title: 'Quality Assurance',
            description: 'Rigorous quality checks and compliance with international standards'
          },
          {
            title: 'Flexible Solutions',
            description: 'Customized distribution plans for businesses of all sizes'
          }
        ]
      }
    },
    viyaCrab: {
      title: 'VIYA CRAB',
      subtitle: 'Premium Pasteurized Crab Meat from Thailand',
      productsTitle: 'Products',
      featuredClient: {
        title: 'VIYA CRAB',
        name: 'Premium Pasteurized Crab Meat (Thailand)',
        description: 'Viya Crab (Siam Crab Products Co., Ltd.) is one of the most respected Thai producers of hand-picked, pasteurized Blue Swimming Crab meat. The company operates with full vertical integration, managing every stage from sourcing to final packaging to ensure consistent quality and a stable flow of products throughout the year. Viya Crab products benefit from a refrigerated shelf life of up to 18 months and meet the highest international food safety standards, being certified BRC Grade A, ISO 9001:2015, HACCP and GMP. The entire production process is supported by rigorous sustainability practices and a complete traceability system, guaranteeing transparency and accountability in the supply chain.',
        features: ['Colossal Lump – top-grade, 40–50 pcs', 'Jumbo Lump – 75–110 pcs', 'Super Lump – premium blend', 'Backfin Lump – large mixed pieces', 'Special – flake-style meat', 'Claw Meat – rich, flavourful, ideal for soups & bisques']
      }
    },
    agricola: {
      title: 'GOLDEN SHEAF',
      subtitle: 'Premium Wheat, Expertly Milled for Reliable Results.',
      intro: 'A sheaf is not just a bundle of wheat; it is a symbol of the harvest\'s best. At Golden Sheaf, we believe superior flour begins with quality wheat cultivated in the right regions and perfected through precise, modern milling. We source wheat varieties known for their natural strength, stability, and baking performance. Each batch is carefully graded and tested for key indicators such as protein quality, moisture, and overall purity before entering the mill.\n\nThrough controlled cleaning, conditioning, and advanced milling techniques, we preserve the grain\'s natural character while achieving the consistency that bakeries and professional kitchens rely on.\n\nNo unnecessary additives. No fluctuation between batches. Just clean, reliable flour engineered for high-volume applications, from daily breads to pastries and flatbreads.\n\nFrom well-selected wheat fields to high-precision milling and dependable supply, Golden Sheaf delivers the strength, texture, and consistency your operation depends on.',
      product: {
        title: 'Our Product',
        name: 'Golden Sheaf Premium Flour',
        weight: '25KG',
        subtitle: 'Professional Milling Performance',
        description: 'Premium wheat flour engineered for high-volume bakery and food processing applications. Each 25kg bag delivers consistent protein quality, optimal moisture content, and reliable baking performance batch after batch.',
        features: [
          'Professional-grade wheat flour',
          'Consistent protein quality and texture',
          'Ideal for breads, pastries, and flatbreads',
          'Tested for purity and performance',
          '25KG professional packaging',
          'Clean ingredients, no unnecessary additives'
        ],
        image: 'https://customer-assets.emergentagent.com/job_mea-connect/artifacts/irq9ea9g_ChatGPT%20Image%20Dec%206%2C%202025%20at%2012_57_15%20PM.png'
      },
      capabilities: {
        title: 'Distribution Capabilities',
        items: [
          {
            title: 'Quality Control',
            description: 'Comprehensive testing to ensure consistent flour quality and performance.'
          },
          {
            title: 'Bulk Supply',
            description: 'Reliable large-volume supply with controlled storage, secure packaging, and coordinated dispatch for distributors, bakeries, and industrial clients.'
          },
          {
            title: 'Reliable Partnerships',
            description: 'Strong relationships with verified suppliers and trusted distribution networks'
          }
        ]
      }
    },
    trading: {
      title: 'Trading',
      subtitle: 'Global sourcing and trading of agricultural commodities',
      intro: 'With extensive experience in international commodity trading, we connect buyers and sellers across continents, specializing in agricultural products and raw materials.',
      products: {
        title: 'Product Categories',
        items: [
          {
            title: 'Grains',
            description: 'High-quality wheat, corn, barley, and specialty grains in bulk quantities for food processing and commercial milling operations'
          },
          {
            title: 'Chemical Fertilizers',
            description: 'Agricultural chemical fertilizers including NPK compounds, urea, phosphates, and specialty formulations for crop optimization and soil enhancement'
          }
        ]
      },
      approach: {
        title: 'Our Trading Approach',
        items: [
          'Supplier verification and qualification',
          'Quality control and inspection',
          'Competitive pricing and terms',
          'Documentation and compliance',
          'Logistics coordination',
          'Risk management'
        ]
      }
    },
    contact: {
      title: 'Contact Us',
      subtitle: 'Get in touch with our team',
      email: 'Email',
      address: 'Address',
      addressValue: 'FDAM0223, Compass Building, Al Shohada Road, Ras Al Khaimah, United Arab Emirates',
      globalPresence: {
        title: 'Global Presence',
        description: 'Operating across the Middle East, Asia, Europe, and Africa, connecting markets and creating opportunities.'
      },
      basedIn: {
        title: 'Based in the Heart of the UAE'
      },
      readyToConnect: {
        title: 'Ready to Get in Touch?',
        subtitle: 'When contacting us, please let us know:',
        items: [
          'Your industry',
          'Your company name',
          'Your WhatsApp number',
          'How we can help you'
        ],
        button: 'Send Us an Email'
      }
    },
    footer: {
      description: 'Excellence Delivered Across Borders',
      rights: 'All rights reserved.',
      terms: 'Terms & Conditions'
    },
    offer: {
      title: 'What We Offer',
      subtitle: 'Tailored solutions to help your business succeed in international markets'
    },
    whyWorkWithUs: {
      title: 'Why Work With Us',
      subtitle: 'Partnering with ARIA MEA means working with a team that prioritizes your success',
      viewAllServices: 'View All Services'
    },
    globalReach: {
      title: 'Our Global Reach',
      subtitle: 'Operating across multiple regions with local expertise and international standards',
      middleEast: {
        title: 'Middle East',
        description: 'Based in Dubai with deep understanding of UAE and GCC markets, regulations, and business culture'
      },
      asia: {
        title: 'Asia',
        description: 'We connect Europe, Asia, and the Middle East through bidirectional trade flows, sourcing from key producers and delivering high-quality products to regional buyers.'
      },
      europeAfrica: {
        title: 'Europe and Africa',
        description: 'Strong supplier networks and bidirectional trade capabilities in chemical fertilizers and grains across European and African markets.'
      }
    },
    process: {
      title: 'Our Process',
      subtitle: 'A proven approach to delivering exceptional results',
      steps: [
        { title: 'Discovery', description: 'Understanding your business needs, goals, and challenges through in-depth consultation' },
        { title: 'Strategy', description: 'Developing a customized plan with clear milestones and actionable steps' },
        { title: 'Execution', description: 'Implementing solutions with precision, coordination, and constant communication' },
        { title: 'Optimization', description: 'Continuous monitoring and improvement to ensure sustained success' }
      ]
    },
    cta: {
      services: { title: 'Ready to Expand Your Business?', subtitle: "Let's discuss how our services can help you achieve your goals in the Middle East and beyond.", button: 'Get in Touch' },
      distribution: { title: 'Looking to Expand Your Reach Across Middle East and Asia?', subtitle: 'Reliable Supply, Engineered for Your Market Needs.', button: 'Contact Us' },
      trading: { title: 'Ready to Start Trading?', subtitle: 'Connect with verified suppliers and access high-quality products across continents.', button: 'Get Started' }
    }
  },
  ro: {
    nav: {
      about: 'Acasă',
      services: 'Servicii',
      distribution: 'Distribuție',
      trading: 'Trading',
      contact: 'Contact'
    },
    hero: {
      title: 'EXCELENȚĂ ÎN OPERAȚIUNI GLOBALE',
      subtitle: 'Conectăm Europa, Asia și Orientul Mijlociu prin fluxuri comerciale bidirecționale, aprovizionând de la producători cheie și livrând produse de înaltă calitate către cumpărători regionali.'
    },
    about: {
      title: 'Despre Noi',
      companyName: 'ARIA MEA Ventures',
      description1: 'Cu sediul în Emiratele Arabe Unite, operăm ca un punct esențial de conectare între piețele internaționale și partenerii care activează în HoReCa, FMCG și sectoarele conexe. Suntem o companie nouă ca identitate, dar construită pe o experiență puternică acumulată în ani de proiecte derulate în regiune și pe piețe globale. Experiența acumulată în proiecte internaționale ne permite să operăm cu claritate, viteză și un nivel ridicat de responsabilitate',
      description2: 'Știm că, în mediul actual, simpla livrare a unui produs nu mai este suficientă. Ne asumăm rolul de partener strategic și adaptăm soluțiile exact la cerințele fiecărui client. Nu lucrăm după șabloane rigide; analizăm, ajustăm și personalizăm abordarea fie că este vorba despre identificarea unor produse de nișă, fie despre gestionarea unor rute logistice complexe pentru a oferi acuratețe și rezultate măsurabile.',
      stat1: '15+ Ani',
      stat1Label: 'Activitate Directă',
      stat2: '$60M+',
      stat2Label: 'Valoare Tranzacțională Globală',
      stat3: '60.000+',
      stat3Label: 'Tone Tranzacționate',
      description3: 'Ceea ce ne diferențiază este disciplina cu care operăm și angajamentul față de performanță. Ne implicăm până la capăt, cu respect față de obiectivele partenerilor și focus pe rezultate. Înțelegem provocările reale din lanțurile de aprovizionare și le abordăm cu determinare, până când proiectul este finalizat. Construim relații bazate pe încredere, claritate și rezultate care vorbesc de la sine.'
    },
    services: {
      title: 'Servicii',
      subtitle: 'Soluții integrate pentru companii care își extind operațiunile în Orientul Mijlociu și Asia. De la intrarea pe piață și aprovizionare până la logistică și reprezentare locală, oferim suport activ, bazat pe experiență practică în regiune.',
      whatWeOffer: 'Ce Oferim:',
      service1: {
        title: 'Suport pentru Expansiune pe Piață',
        description: 'Deblochează noi oportunități în UAE și GCC cu perspective țintite și înțelegere directă a dinamicii regionale. Ajutăm brandurile să intre pe piețe noi eficient, reducând riscul și incertitudinea.',
        benefits: [
          'Cercetare de piață și studii de fezabilitate',
          'Conformitate regulatorie și suport pentru licențiere',
          'Identificare parteneri locali',
          'Strategii de adaptare culturală',
          'Evaluare riscuri și planificare mitigare'
        ]
      },
      service2: {
        title: 'Aprovizionare și Trading Transfrontalier',
        description: 'Obține acces la furnizori de încredere din Europa, Asia și Africa. Gestionăm aprovizionarea, verificarea furnizorilor, documentația de conformitate și execuția tranzacțiilor pentru un flux constant.',
        benefits: [
          'Rețea verificată de furnizori pe 3 continente',
          'Control calitate și inspecție produse',
          'Negocieri prețuri competitive',
          'Documentație completă și conformitate',
          'Coordonare transport containere și en-gros'
        ]
      },
      service3: {
        title: 'Logistică și Coordonare Lanț de Aprovizionare',
        description: 'Asigură livrări coordonate logistic, manipulare portuară și supraveghere transport. Acoperim produse de la făină și materii prime FMCG până la fructe de mare premium, asigurând claritate și control peste frontiere.',
        benefits: [
          'Management logistic end-to-end',
          'Soluții lanț frigorific cu control temperatură',
          'Manipulare portuară și vămuire',
          'Urmărire transport în timp real',
          'Asigurare și management risc'
        ]
      },
      service4: {
        title: 'Dezvoltare Afaceri și Reprezentare Locală',
        description: 'Extinde-ți prezența în Orientul Mijlociu cu un partener care înțelege regiunea. Sprijinim demersuri B2B, conexiuni cu distribuitori și poziționare brand pentru companiile care intră sau cresc în UAE.',
        benefits: [
          'Networking B2B și introduceri',
          'Conexiuni cu distribuitori și retaileri',
          'Poziționare brand și strategie intrare piață',
          'Dezvoltare canale vânzare',
          'Facilitare parteneriate pe termen lung'
        ]
      }
    },
    whyUs: {
      title: 'De Ce Să Lucrezi Cu Noi',
      reason1: {
        title: 'Încredere',
        description: 'Operăm cu transparență și integritate în aprovizionare, verificare și livrare. Informații clare, termene oneste și urmărire consecventă—fără surprize sau promisiuni exagerate.'
      },
      reason2: {
        title: 'Fiabilitate',
        description: 'Prioritizăm aprovizionarea fiabilă și execuția previzibilă prin coordonare disciplinată, furnizori verificați și logistică perfectă pentru a reduce incertitudinea.'
      },
      reason3: {
        title: 'Aliniere la Produse de Nișă',
        description: 'Ne concentrăm pe produse specializate de valoare mare cu goluri de piață, potrivind nevoile specifice cu cele mai bune opțiuni de aprovizionare pentru a asigura relevanță, calitate și valoare pe termen lung.'
      },
      reason4: {
        title: 'Cunoaștere de Piață',
        description: 'Peste un deceniu de experiență în UAE cu conexiuni puternice în Europa, Asia și Balcani. Înțelegem așteptările pieței, nuanțele culturale și cerințele operaționale.'
      },
      reason5: {
        title: 'Abordare de Parteneriat pe Termen Lung',
        description: 'Ne concentrăm pe relații sustenabile mai degrabă decât pe tranzacții, construind parteneriate stabile, reciproc avantajoase, care cresc în timp cu grupuri hoteliere, distribuitori sau clienți industriali.'
      },
      closing: 'Cu ani de experiență în dezvoltare de afaceri și aprovizionare inter-regională, ARIA MEA Ventures acționează ca partener strategic angajat în transparență, operațiuni fiabile și soluții personalizate.'
    },
    distribution: {
      title: 'Distribuție',
      subtitle: 'Rețele de distribuție fiabile care conectează produse premium cu piețele regionale',
      intro: 'Oferim soluții complete de distribuție în Orientul Mijlociu, asigurându-ne că produsele tale ajung pe piețele potrivite cu cele mai înalte standarde de calitate și eficiență.',
      productsTitle: 'Produse',
      featuredClient: {
        title: 'VIYA CRAB',
        name: 'Carne Premium de Crab Pasteurizată (Thailanda)',
        description: 'Viya Crab (Siam Crab Products Co., Ltd.) este unul dintre cei mai respectați producători thailandezi de carne de crab albastru înotător, pasteurizată și selecționată manual. Compania operează cu integrare verticală completă, gestionând fiecare etapă de la aprovizionare până la ambalarea finală pentru a asigura calitate constantă și un flux stabil de produse pe tot parcursul anului. Produsele Viya Crab beneficiază de o durată de viață refrigerată de până la 18 luni și respectă cele mai înalte standarde internaționale de siguranță alimentară, fiind certificate BRC Grade A, ISO 9001:2015, HACCP și GMP. Întregul proces de producție este susținut de practici riguroase de sustenabilitate și de un sistem complet de trasabilitate, garantând transparență și responsabilitate în lanțul de aprovizionare.',
        features: ['Colossal Lump – calitate superioară, 40–50 buc', 'Jumbo Lump – 75–110 buc', 'Super Lump – amestec premium', 'Backfin Lump – bucăți mari mixte', 'Special – carne tip fulgi', 'Claw Meat – bogată, savuroasă, ideală pentru supe și bisque']
      },
      capabilities: {
        title: 'Capabilități de Distribuție',
        items: [
          {
            title: 'Logistică cu Control Temperatură',
            description: 'Management de ultimă generație al lanțului frigorific pentru fructe de mare și produse perisabile'
          },
          {
            title: 'Acoperire Regională',
            description: 'Rețea extinsă în UAE, Arabia Saudită, Qatar și întreaga regiune GCC'
          },
          {
            title: 'Asigurarea Calității',
            description: 'Verificări riguroase ale calității și conformitate cu standardele internaționale'
          },
          {
            title: 'Soluții Flexibile',
            description: 'Soluții de distribuție flexibile și scalabile.'
          }
        ]
      }
    },
    viyaCrab: {
      title: 'VIYA CRAB',
      subtitle: 'Carne Premium de Crab Pasteurizată din Thailanda',
      productsTitle: 'Produse',
      featuredClient: {
        title: 'VIYA CRAB',
        name: 'Carne Premium de Crab Pasteurizată (Thailanda)',
        description: 'Viya Crab (Siam Crab Products Co., Ltd.) este unul dintre cei mai respectați producători thailandezi de carne de crab albastru înotător, pasteurizată și selecționată manual. Compania operează cu integrare verticală completă, gestionând fiecare etapă de la aprovizionare până la ambalarea finală pentru a asigura calitate constantă și un flux stabil de produse pe tot parcursul anului. Produsele Viya Crab beneficiază de o durată de viață refrigerată de până la 18 luni și respectă cele mai înalte standarde internaționale de siguranță alimentară, fiind certificate BRC Grade A, ISO 9001:2015, HACCP și GMP. Întregul proces de producție este susținut de practici riguroase de sustenabilitate și de un sistem complet de trasabilitate, garantând transparență și responsabilitate în lanțul de aprovizionare.',
        features: ['Colossal Lump – calitate superioară, 40–50 buc', 'Jumbo Lump – 75–110 buc', 'Super Lump – amestec premium', 'Backfin Lump – bucăți mari mixte', 'Special – carne tip fulgi', 'Claw Meat – bogată, savuroasă, ideală pentru supe și bisque']
      }
    },
    agricola: {
      title: 'GOLDEN SHEAF',
      subtitle: 'Faina din Grâu Premium, Măcinat cu Precizie pentru Rezultate Fiabile.',
      intro: 'Un snop nu este doar un mănunchi de grâu, este simbolul celor mai bune roade ale recoltei. La Golden Sheaf, credem că o făină superioară începe cu grâu de calitate, provenit din zone agricole recunoscute pentru stabilitatea culturilor și desăvârșit prin măcinare modernă și precisă. Selectăm soiuri de grâu recunoscute pentru rezistența naturală, stabilitatea și performanța lor în panificație. Fiecare lot este atent analizat și testat pentru indicatori esențiali precum calitatea proteinei, umiditatea și nivelul general de puritate înainte de procesare.\n\nPrin etape controlate de curățare, condiționare și tehnici avansate de măcinare, păstrăm caracterul natural al boabelor, asigurând în același timp consistența de care depind brutăriile și bucătăriile profesionale.\n\nFără aditivi inutili. Fără variații între loturi. Doar o făină curată și fiabilă, creată pentru aplicații de volum mare, de la pâinea zilnică până la produse de patiserie și flatbread-uri.\n\nDe la furnizori atent aleși și boabe evaluate riguros, până la măcinarea de înaltă precizie și un lanț de aprovizionare sigur, Golden Sheaf oferă forța, textura și consistența pe care se bazează operațiunile dumneavoastră.',
      product: {
        title: 'Produsul Nostru',
        name: 'Făină Premium Golden Sheaf',
        weight: '25KG',
        subtitle: 'Performanță Profesională de Măcinare',
        description: 'Făină de grâu premium creată pentru aplicații de brutărie și procesare alimentară la scară mare. Fiecare sac de 25kg oferă calitate constantă a proteinei, conținut optim de umiditate și performanță fiabilă în panificație, lot după lot.',
        features: [
          'Făină de grâu de calitate profesională',
          'Calitate constantă a proteinei și texturii',
          'Ideală pentru pâine, patiserie și flatbread-uri',
          'Testată pentru puritate și performanță',
          'Ambalaj profesional de 25KG',
          'Ingrediente curate, fără aditivi inutili'
        ],
        image: 'https://customer-assets.emergentagent.com/job_mea-connect/artifacts/irq9ea9g_ChatGPT%20Image%20Dec%206%2C%202025%20at%2012_57_15%20PM.png'
      },
      capabilities: {
        title: 'Capabilități de Distribuție',
        items: [
          {
            title: 'Controlul Calității',
            description: 'Testare cuprinzătoare pentru a asigura o calitate și o performanță constantă a făinii.'
          },
          {
            title: 'Aprovizionare en-gros',
            description: 'Aprovizionare fiabilă în volume mari, cu depozitare controlată, ambalare sigură și expediere coordonată pentru distribuitori, mori, brutării și clienți industriali.'
          },
          {
            title: 'Parteneriate Fiabile',
            description: 'Relații puternice cu furnizori verificați și rețele de distribuție de încredere'
          }
        ]
      }
    },
    trading: {
      title: 'Trading',
      subtitle: 'Aprovizionare globală și trading de mărfuri agricole',
      intro: 'Gestionăm operațiuni de comerț internațional, conectând parteneri din diferite regiuni și livrând produse agricole și materii prime către piețe globale.',
      products: {
        title: 'Categorii de Produse',
        items: [
          {
            title: 'Grâne',
            description: 'Grâu, porumb, orz și cereale speciale de înaltă calitate în cantități mari pentru procesare alimentară și operațiuni de moară comercială'
          },
          {
            title: 'Îngrășăminte Chimice',
            description: 'Îngrășăminte chimice agricole inclusiv compuși NPK, uree, fosfați și formulări speciale pentru optimizarea culturilor și îmbunătățirea solului'
          }
        ]
      },
      approach: {
        title: 'Abordarea Noastră în Trading',
        items: [
          'Verificarea și calificarea furnizorilor',
          'Control și inspecție de calitate',
          'Prețuri și termene competitive',
          'Documentație și conformitate',
          'Coordonare logistică',
          'Gestionarea riscurilor'
        ]
      }
    },
    contact: {
      title: 'Contactați-ne',
      subtitle: 'Luați legătura cu echipa noastră',
      email: 'Email',
      address: 'Adresă',
      addressValue: 'FDAM0223, Compass Building, Al Shohada Road, Ras Al Khaimah, Emiratele Arabe Unite',
      globalPresence: {
        title: 'Prezență Globală',
        description: 'Operăm în Orientul Mijlociu, Asia, Europa și Africa, conectând piețe și creând oportunități.'
      },
      basedIn: {
        title: 'Poziționați strategic în Emiratele Arabe Unite'
      },
      readyToConnect: {
        title: 'Gata să Luați Legătura?',
        subtitle: 'Când ne contactați, vă rugăm să ne spuneți:',
        items: [
          'Din ce industrie sunteți',
          'Numele companiei',
          'Numărul dvs. de WhatsApp',
          'Cu ce vă putem ajuta'
        ],
        button: 'Trimiteți-ne Email'
      }
    },
    footer: {
      description: 'Excelență în operațiuni globale',
      rights: 'Toate drepturile rezervate.',
      terms: 'Termeni și Condiții'
    },
    offer: {
      title: 'Ce Oferim',
      subtitle: 'Soluții personalizate pentru a ajuta afacerea dvs. să reușească pe piețele internaționale'
    },
    whyWorkWithUs: {
      title: 'De Ce Să Lucrezi Cu Noi',
      subtitle: 'Parteneriatul cu ARIA MEA înseamnă colaborarea cu o echipă care prioritizează succesul dvs.',
      viewAllServices: 'Vezi Toate Serviciile'
    },
    globalReach: {
      title: 'Acoperirea Noastră Globală',
      subtitle: 'Operăm în mai multe regiuni cu expertiză locală și standarde internaționale',
      middleEast: {
        title: 'Orientul Mijlociu',
        description: 'Bazați în Dubai cu o înțelegere profundă a piețelor UAE și GCC, reglementărilor și culturii de afaceri'
      },
      asia: {
        title: 'Asia',
        description: 'Conectăm Europa, Asia și Orientul Mijlociu prin fluxuri comerciale bidirecționale, aprovizionând de la producători cheie și livrând produse de înaltă calitate către cumpărători regionali.'
      },
      europeAfrica: {
        title: 'Europa și Africa',
        description: 'Rețele puternice de furnizori și capacități comerciale bidirecționale în îngrășăminte chimice și cereale pe piețele europene și africane.'
      }
    },
    process: {
      title: 'Procesul Nostru',
      subtitle: 'O abordare dovedită pentru a oferi rezultate excepționale',
      steps: [
        { title: 'Descoperire', description: 'Înțelegerea nevoilor, obiectivelor și provocărilor afacerii dvs. prin consultare aprofundată' },
        { title: 'Strategie', description: 'Dezvoltarea unui plan personalizat cu etape clare și pași acționabili' },
        { title: 'Execuție', description: 'Implementarea soluțiilor cu precizie, coordonare și comunicare constantă' },
        { title: 'Optimizare', description: 'Monitorizare continuă și îmbunătățire pentru a asigura succesul susținut' }
      ]
    },
    cta: {
      services: { title: 'Gata să Vă Extindeți Afacerea?', subtitle: 'Haideți să discutăm cum serviciile noastre vă pot ajuta să vă atingeți obiectivele în Orientul Mijlociu și dincolo.', button: 'Contactați-ne' },
      distribution: { title: 'Doriți să vă consolidați prezența în Orientul Mijlociu?', subtitle: 'Soluții de distribuție adaptate, construite pentru performanță și continuitate.', button: 'Contactați-ne' },
      trading: { title: 'Gata să Începeți Trading-ul?', subtitle: 'Conectați-vă cu furnizori verificați și accesați produse de înaltă calitate pe continente.', button: 'Începeți' }
    }
  },
  ar: {
    nav: {
      about: 'الرئيسية',
      services: 'خدماتنا',
      distribution: 'التوزيع',
      trading: 'التجارة',
      contact: 'اتصل بنا'
    },
    hero: {
      title: 'متجذرون في الإمارات، متصلون بالعالم',
      subtitle: 'نربط أوروبا وآسيا والشرق الأوسط من خلال تدفقات تجارية ثنائية الاتجاه، والتوريد من المنتجين الرئيسيين وتسليم منتجات عالية الجودة للمشترين الإقليميين.'
    },
    about: {
      title: 'من نحن',
      companyName: 'أريا الشرق الأوسط وأفريقيا',
      description1: 'يقع مقرنا الاستراتيجي في الإمارات العربية المتحدة، ونعمل كحلقة وصل حيوية في سلسلة التوريد العالمية للسلع ومنتجات الفنادق والمطاعم والتموين ومنتجات السلع الاستهلاكية سريعة الحركة. على الرغم من أننا وجه جديد في الصناعة، إلا أن أساسنا مبني على عقود من الخبرة الجماعية. نقدم ميزة فريدة: الحكمة السوقية العميقة للمحاربين القدامى المتمرسين مع خفة الحركة واستجابة المشغل الحديث.',
      description2: 'نحن نفهم أنه في سوق اليوم المعقد، مجرد تسليم المنتج لا يكفي. نفخر بكوننا شريكاً استراتيجياً يصمم الحلول لتناسب متطلباتك بالضبط. نحن لا نؤمن بالعمليات الجامدة، بل نستمع ونتكيف ونخصص نهجنا سواء كان الأمر يتعلق بتوريد منتجات متخصصة أو التنقل في سلاسل التوريد الصعبة لضمان تحقيق أهدافك التشغيلية بدقة.',
      stat1: '+15 سنوات',
      stat1Label: 'نشاط عملي',
      stat2: '+60 مليون دولار',
      stat2Label: 'قيمة المعاملات العالمية',
      stat3: '+60,000',
      stat3Label: 'طن تم تداوله',
      description3: 'ما يميزنا هو التزامنا الذي لا يتزعزع بالتميز. نذهب إلى أبعد من معظم الآخرين لتأمين نجاحك، مدفوعين بعقلية موجهة نحو النتائج واحترام عميق لأهداف شركائنا. نحن نفهم تحدياتك الفريدة ومع ذلك نحن مصممون على التغلب على العقبات وإنجاز المهمة. نحن هنا لبناء سمعة تستند إلى الثقة والشفافية والنتائج التي تتحدث عن نفسها.'
    },
    services: {
      title: 'خدماتنا',
      subtitle: 'حلول شاملة للشركات التي تتوسع في الشرق الأوسط وآسيا وما وراءها. من الدخول إلى السوق إلى تنفيذ اللوجستيات، نقدم دعماً عملياً مدعوماً بسنوات من الخبرة الميدانية.',
      whatWeOffer: 'ما نقدمه:',
      service1: {
        title: 'دعم التوسع في السوق',
        description: 'افتح فرصًا جديدة في الإمارات ودول مجلس التعاون الخليجي من خلال رؤى مستهدفة وفهم أرضي للديناميكيات الإقليمية. نساعد العلامات التجارية على دخول أسواق جديدة بكفاءة مع تقليل المخاطر والشكوك.',
        benefits: [
          'أبحاث السوق ودراسات الجدوى',
          'الامتثال التنظيمي ودعم الترخيص',
          'تحديد الشركاء المحليين',
          'استراتيجيات التكيف الثقافي',
          'تقييم المخاطر وتخطيط التخفيف'
        ]
      },
      service2: {
        title: 'التوريد والتجارة عبر الحدود',
        description: 'احصل على وصول إلى موردين موثوقين عبر أوروبا وآسيا وأفريقيا. نحن ندير التوريد والتحقق من الموردين ووثائق الامتثال وتنفيذ التجارة من أجل إمدادات سلسة ومتسقة.',
        benefits: [
          'شبكة موردين معتمدة عبر 3 قارات',
          'مراقبة الجودة وفحص المنتجات',
          'مفاوضات الأسعار التنافسية',
          'الوثائق الكاملة والامتثال',
          'تنسيق شحن الحاويات والشحن بالجملة'
        ]
      },
      service3: {
        title: 'اللوجستيات وتنسيق سلسلة التوريد',
        description: 'تأمين التسليم من خلال الخدمات اللوجستية المنسقة ومناولة الموانئ والإشراف على الشحن. نغطي المنتجات من الدقيق والمواد الخام لمنتجات FMCG إلى المأكولات البحرية المتميزة، مما يضمن الوضوح والتحكم عبر الحدود.',
        benefits: [
          'إدارة لوجستية شاملة',
          'حلول السلسلة الباردة المتحكم بدرجة الحرارة',
          'مناولة الموانئ والتخليص الجمركي',
          'تتبع الشحنات في الوقت الفعلي',
          'التأمين وإدارة المخاطر'
        ]
      },
      service4: {
        title: 'تطوير الأعمال والتمثيل المحلي',
        description: 'قم بتوسيع تواجدك في الشرق الأوسط مع شريك يفهم المنطقة. ندعم التواصل بين الشركات، وعلاقات الموزعين، وتحديد موقع العلامة التجارية للشركات الداخلة أو المتنامية في الإمارات.',
        benefits: [
          'الشبكات والتعريفات بين الشركات',
          'علاقات الموزعين وتجار التجزئة',
          'تحديد موقع العلامة التجارية واستراتيجية دخول السوق',
          'تطوير قنوات المبيعات',
          'تسهيل الشراكات طويلة الأجل'
        ]
      }
    },
    whyUs: {
      title: 'لماذا العمل معنا',
      reason1: {
        title: 'الثقة',
        description: 'نعمل بشفافية ونزاهة في التوريد والتحقق والتسليم. معلومات واضحة، جداول زمنية صادقة، ومتابعة متسقة - لا مفاجآت أو وعود مبالغ فيها.'
      },
      reason2: {
        title: 'الموثوقية',
        description: 'نعطي الأولوية للإمدادات الموثوقة والتنفيذ القابل للتنبؤ من خلال التنسيق المنضبط والموردين المعتمدين والخدمات اللوجستية السلسة لتقليل عدم اليقين.'
      },
      reason3: {
        title: 'التوافق مع المنتجات المتخصصة',
        description: 'نركز على المنتجات المتخصصة عالية القيمة مع فجوات السوق، ومطابقة الاحتياجات المحددة مع أفضل خيارات التوريد لضمان الملاءمة والجودة والقيمة طويلة الأجل.'
      },
      reason4: {
        title: 'معرفة السوق',
        description: 'أكثر من عقد من الخبرة في الإمارات مع علاقات قوية عبر أوروبا وآسيا والبلقان. نحن نفهم توقعات السوق والفروق الثقافية والمتطلبات التشغيلية.'
      },
      reason5: {
        title: 'نهج الشراكة طويلة الأجل',
        description: 'نركز على العلاقات المستدامة بدلاً من المعاملات، وبناء شراكات مستقرة ومفيدة للطرفين تنمو مع مرور الوقت مع مجموعات الفنادق أو الموزعين أو العملاء الصناعيين.'
      },
      closing: 'مع سنوات من تطوير الأعمال والتوريد عبر المناطق، تعمل أريا الشرق الأوسط وأفريقيا كشريك استراتيجي ملتزم بالشفافية والعمليات الموثوقة والحلول المصممة خصيصًا.'
    },
    distribution: {
      title: 'التوزيع',
      subtitle: 'شبكات توزيع موثوقة تربط المنتجات المتميزة بالأسواق الإقليمية',
      intro: 'نحن نقدم حلول توزيع شاملة في جميع أنحاء الشرق الأوسط، مما يضمن وصول منتجاتك إلى الأسواق المناسبة بأعلى معايير الجودة والكفاءة.',
      productsTitle: 'المنتجات',
      featuredClient: {
        title: 'VIYA CRAB',
        name: 'لحم السلطعون المبستر المتميز (تايلاند)',
        description: 'فيا كراب (شركة سيام كراب برودكتس المحدودة) هي شركة تايلاندية رائدة في إنتاج لحم سلطعون السباحة الأزرق المبستر والمنتقى يدوياً، وتعمل بتكامل رأسي كامل من التوريد إلى التعبئة النهائية. تقدم منتجاتها فترة صلاحية مبردة تصل إلى 18 شهراً، وجودة ثابتة، وموثوقية في الإمداد على مدار العام. تلبي فيا كراب أعلى معايير سلامة الأغذية العالمية بشهادات BRC الدرجة A، وISO 9001:2015، وHACCP، وGMP، مدعومة ببرامج استدامة قوية وإمكانية تتبع كاملة عبر سلسلة الإنتاج.',
        features: ['كتل عملاقة – درجة ممتازة، 40-50 قطعة', 'كتل كبيرة – 75-110 قطعة', 'كتل فاخرة – خليط ممتاز', 'كتل الظهر – قطع كبيرة مختلطة', 'خاصة – لحم على شكل رقائق', 'لحم المخلب – غني النكهة، مثالي للشوربات والبسك']
      },
      capabilities: {
        title: 'قدرات التوزيع',
        items: [
          {
            title: 'لوجستيات يتحكم بها درجة الحرارة',
            description: 'إدارة سلسلة التبريد الحديثة للمأكولات البحرية والمنتجات القابلة للتلف'
          },
          {
            title: 'التغطية الإقليمية',
            description: 'شبكة واسعة في جميع أنحاء الإمارات والسعودية وقطر ومنطقة مجلس التعاون الخليجي الأوسع'
          },
          {
            title: 'ضمان الجودة',
            description: 'فحوصات جودة صارمة والامتثال للمعايير الدولية'
          },
          {
            title: 'حلول مرنة',
            description: 'خطط توزيع مخصصة للشركات من جميع الأحجام'
          }
        ]
      }
    },
    viyaCrab: {
      title: 'VIYA CRAB',
      subtitle: 'لحم السلطعون المبستر المتميز من تايلاند',
      productsTitle: 'المنتجات',
      featuredClient: {
        title: 'VIYA CRAB',
        name: 'لحم السلطعون المبستر المتميز (تايلاند)',
        description: 'فيا كراب (شركة سيام كراب برودكتس المحدودة) هي شركة تايلاندية رائدة في إنتاج لحم سلطعون السباحة الأزرق المبستر والمنتقى يدوياً، وتعمل بتكامل رأسي كامل من التوريد إلى التعبئة النهائية. تقدم منتجاتها فترة صلاحية مبردة تصل إلى 18 شهراً، وجودة ثابتة، وموثوقية في الإمداد على مدار العام. تلبي فيا كراب أعلى معايير سلامة الأغذية العالمية بشهادات BRC الدرجة A، وISO 9001:2015، وHACCP، وGMP، مدعومة ببرامج استدامة قوية وإمكانية تتبع كاملة عبر سلسلة الإنتاج.',
        features: ['كتل عملاقة – درجة ممتازة، 40-50 قطعة', 'كتل كبيرة – 75-110 قطعة', 'كتل فاخرة – خليط ممتاز', 'كتل الظهر – قطع كبيرة مختلطة', 'خاصة – لحم على شكل رقائق', 'لحم المخلب – غني النكهة، مثالي للشوربات والبسك']
      }
    },
    agricola: {
      title: 'GOLDEN SHEAF',
      subtitle: 'قمح ممتاز، مطحون بخبرة لنتائج موثوقة.',
      intro: 'نحن متخصصون في توزيع المنتجات الزراعية عالية الجودة، بما في ذلك الدقيق والحبوب والأسمدة في منطقة الشرق الأوسط.',
      product: {
        title: 'منتجنا',
        name: 'دقيق ذهبي شيف الممتاز',
        weight: '25 كجم',
        subtitle: 'أداء طحن احترافي',
        description: 'دقيق قمح ممتاز مصمم لتطبيقات المخابز ومعالجة الأغذية ذات الحجم الكبير. كل كيس 25 كجم يقدم جودة بروتين ثابتة، محتوى رطوبة مثالي، وأداء خبز موثوق دفعة بعد دفعة.',
        features: [
          'دقيق قمح بجودة احترافية',
          'جودة بروتين وقوام ثابتة',
          'مثالي للخبز والمعجنات والفطائر المسطحة',
          'مختبر من حيث النقاء والأداء',
          'تعبئة احترافية 25 كجم',
          'مكونات نظيفة، بدون إضافات غير ضرورية'
        ],
        image: 'https://customer-assets.emergentagent.com/job_mea-connect/artifacts/irq9ea9g_ChatGPT%20Image%20Dec%206%2C%202025%20at%2012_57_15%20PM.png'
      },
      capabilities: {
        title: 'قدرات التوزيع',
        items: [
          {
            title: 'مراقبة الجودة',
            description: 'فحوصات جودة صارمة والامتثال للمعايير الزراعية الدولية'
          },
          {
            title: 'التوريد بالجملة',
            description: 'معالجة فعالة وتوزيع المنتجات الزراعية بالجملة'
          },
          {
            title: 'شراكات موثوقة',
            description: 'علاقات قوية مع موردين معتمدين وشبكات توزيع موثوقة'
          }
        ]
      }
    },
    trading: {
      title: 'التجارة',
      subtitle: 'التوريد العالمي وتجارة السلع الزراعية',
      intro: 'مع خبرة واسعة في تجارة السلع الدولية، نربط المشترين والبائعين عبر القارات، متخصصين في المنتجات الزراعية والمواد الخام.',
      products: {
        title: 'فئات المنتجات',
        items: [
          {
            title: 'الحبوب',
            description: 'القمح والذرة والشعير والحبوب المتخصصة عالية الجودة بكميات كبيرة لمعالجة الأغذية وعمليات الطحن التجارية'
          },
          {
            title: 'الأسمدة الكيميائية',
            description: 'الأسمدة الكيميائية الزراعية بما في ذلك مركبات NPK واليوريا والفوسفات والتركيبات المتخصصة لتحسين المحاصيل وتعزيز التربة'
          }
        ]
      },
      approach: {
        title: 'نهجنا التجاري',
        items: [
          'التحقق من الموردين وتأهيلهم',
          'مراقبة الجودة والتفتيش',
          'الأسعار والشروط التنافسية',
          'التوثيق والامتثال',
          'التنسيق اللوجستي',
          'إدارة المخاطر'
        ]
      }
    },
    contact: {
      title: 'اتصل بنا',
      subtitle: 'تواصل مع فريقنا',
      email: 'البريد الإلكتروني',
      address: 'العنوان',
      addressValue: 'FDAM0223، مبنى كومباس، شارع الشهداء، رأس الخيمة، الإمارات العربية المتحدة',
      globalPresence: {
        title: 'حضور عالمي',
        description: 'نعمل في جميع أنحاء الشرق الأوسط وآسيا وأوروبا وأفريقيا، نربط الأسواق ونخلق الفرص.'
      },
      basedIn: {
        title: 'مقرنا في قلب الإمارات'
      },
      readyToConnect: {
        title: 'هل أنت مستعد للتواصل؟',
        subtitle: 'عند الاتصال بنا، يرجى إخبارنا:',
        items: [
          'مجال عملك',
          'اسم شركتك',
          'رقم الواتساب الخاص بك',
          'كيف يمكننا مساعدتك'
        ],
        button: 'أرسل لنا بريدًا إلكترونيًا'
      }
    },
    footer: {
      description: 'التميز المقدم عبر الحدود',
      rights: 'جميع الحقوق محفوظة.',
      terms: 'الشروط والأحكام'
    },
    offer: {
      title: 'ما نقدمه',
      subtitle: 'حلول مخصصة لمساعدة أعمالك على النجاح في الأسواق الدولية'
    },
    whyWorkWithUs: {
      title: 'لماذا العمل معنا',
      subtitle: 'الشراكة مع ARIA MEA تعني العمل مع فريق يعطي الأولوية لنجاحك',
      viewAllServices: 'عرض جميع الخدمات'
    },
    globalReach: {
      title: 'نطاقنا العالمي',
      subtitle: 'نعمل في مناطق متعددة مع خبرة محلية ومعايير دولية',
      middleEast: {
        title: 'الشرق الأوسط',
        description: 'مقرنا في دبي مع فهم عميق لأسواق الإمارات ودول مجلس التعاون الخليجي واللوائح وثقافة الأعمال'
      },
      asia: {
        title: 'آسيا',
        description: 'نربط أوروبا وآسيا والشرق الأوسط من خلال تدفقات تجارية ثنائية الاتجاه، والتوريد من المنتجين الرئيسيين وتسليم منتجات عالية الجودة للمشترين الإقليميين.'
      },
      europeAfrica: {
        title: 'أوروبا وأفريقيا',
        description: 'شبكات موردين قوية وقدرات تجارية ثنائية الاتجاه في الأسمدة الكيميائية والحبوب عبر الأسواق الأوروبية والأفريقية.'
      }
    },
    process: {
      title: 'عمليتنا',
      subtitle: 'نهج مثبت لتقديم نتائج استثنائية',
      steps: [
        { title: 'الاكتشاف', description: 'فهم احتياجات عملك وأهدافك وتحدياتك من خلال استشارة متعمقة' },
        { title: 'الاستراتيجية', description: 'تطوير خطة مخصصة مع معالم واضحة وخطوات قابلة للتنفيذ' },
        { title: 'التنفيذ', description: 'تنفيذ الحلول بدقة وتنسيق وتواصل مستمر' },
        { title: 'التحسين', description: 'المراقبة المستمرة والتحسين لضمان النجاح المستدام' }
      ]
    },
    cta: {
      services: { title: 'هل أنت مستعد لتوسيع أعمالك؟', subtitle: 'دعنا نناقش كيف يمكن لخدماتنا أن تساعدك على تحقيق أهدافك في الشرق الأوسط وما وراءه.', button: 'تواصل معنا' },
      distribution: { title: 'هل تتطلع إلى تعزيز حضورك في الشرق الأوسط؟', subtitle: 'حلول توزيع مخصصة، مصممة للأداء والاستمرارية.', button: 'اتصل بنا' },
      trading: { title: 'هل أنت مستعد لبدء التداول؟', subtitle: 'تواصل مع موردين معتمدين واحصل على منتجات عالية الجودة عبر القارات.', button: 'ابدأ الآن' }
    }
  }
};

export const images = {
  hero: 'https://images.unsplash.com/photo-1705589244475-7ebbc0d3a842',
  about: 'https://images.unsplash.com/photo-1521791136064-7986c2920216',
  services: [
    'https://images.unsplash.com/photo-1588623731810-171b80f3c55e',
    'https://images.unsplash.com/photo-1564846824194-346b7871b855',
    'https://images.unsplash.com/photo-1741249175179-b85365edc942',
    'https://images.unsplash.com/photo-1497366811353-6870744d04b2'
  ],
  distribution: {
    hero: 'https://images.unsplash.com/photo-1704303923171-d6839e4784c3',
    crab: 'https://en.viyacrabproducts.co.th/images/ready-template/crop-1590031529105.png',
    features: [
      'https://images.unsplash.com/photo-1718117075248-3d3c3cd65264',
      'https://images.pexels.com/photos/4820663/pexels-photo-4820663.jpeg'
    ]
  },
  trading: {
    hero: 'https://images.pexels.com/photos/4820663/pexels-photo-4820663.jpeg',
    products: [
      'https://images.unsplash.com/photo-1714168526009-2d0d333640d5',
      'https://images.unsplash.com/photo-1757670919588-1fe3b3df3dfa'
    ]
  }
};